import React from 'react';
import { useTranslation } from 'react-i18next';

import CatalogHeroVideo from '../../../../assets/img/experiences-catalog/catalog-hero.mp4';

const ExperienceCatalogHero = () => {
  const { t } = useTranslation();

  return (
    <>
      <section className="hero video experience-catalog-hero">
        <div className="experience-catalog-hero__media">
          <video
            className="experience-catalog-hero__video"
            autoPlay
            muted
            playsInline
            controls
            loop
          >
            <source src={CatalogHeroVideo} type="video/mp4" />
            Your browser does not support the video tag.
          </video>
        </div>
      </section>

      <section className="title dark experience-catalog-title experience-catalog-heading">
        <div className="inner experience-catalog-heading__inner">
          <h1 className="experience-catalog-heading__title">
            {t('experiences-catalog-headline')}
            <small className="experience-catalog-heading__subtitle">
              {t('experiences-catalog-introduction')}
            </small>
          </h1>
          <span className="icon-arrow-down experience-catalog-heading__arrow"></span>
        </div>
      </section>
    </>
  );
};

export default ExperienceCatalogHero;
